import SimulationLink from '../components/SimulationLink';

export default {
  render(h) {
    return (
      <div class="py-5">
        <div
          class="shadow-md bg-white rounded mx-3 lg:mx-6 bg-cover bg-top"
          style="background-image: url(/img/changemanagement/epi-cm-welcome.png)"
        >
          <div class="h-full flex flex-col items-center justify-center text-center text-white py-6 lg:py-24 leading-none">
            <img
              src="/img/changemanagement/WHO%20Logo%20Wht_Horz@2x.png"
              alt=""
              class="w-32 lg:w-56 mb-5"
            />
            <h2 class="text-xl lg:text-5xl">Welcome to</h2>
            <h1 class="text-2xl lg:text-6xl">
              <strong>EPI Change Management</strong><br/>
              Simulation
            </h1>
            <SimulationLink
              text="Begin"
              to="what-to-do"
              class="mt-5 lg:mt-20 rounded-full bg-brand-orange-700 hover:bg-orange-700 text-white uppercase py-3 lg:py-2 px-12 lg:px-16 text-lg lg:text-2xl focus:outline-none transition-colors duration-100"
            />
          </div>
        </div>
      </div>
    );
  },
};
